<app-menu-toggle
  tooltip="Import and export options"
  icon="import"
  [active]="false"
  (click)="openIODialog()"
>
</app-menu-toggle>
